import React from "react";
import PropTypes from "prop-types";

// CoversToggle chooses source granularity: "whole" (one project / AI workspace,
// Any type) or "type" (a specific service type, normal builder).
const OPTIONS = [
  { value: "whole", label: "Whole scope" },
  { value: "type", label: "By service type" },
];

const CoversToggle = ({ value, onChange }) => {
  return (
    <div className="inline-flex rounded-seg border border-border overflow-hidden" role="group" aria-label="Covers">
      {OPTIONS.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            onClick={() => {
              if (!active) onChange(o.value);
            }}
            className={`px-3 py-1.5 text-sm ${
              active ? "bg-primary text-white" : "bg-card text-text-2 hover:bg-surface-2"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

CoversToggle.propTypes = {
  value: PropTypes.oneOf(["whole", "type"]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CoversToggle;
